import { createReducer, createActions } from 'reduxsauce';
import get from 'lodash-es/get';

const { Types, Creators } = createActions({
  setSubscriptionLoadRequest: ['month'],
  setSubscriptionLoading: ['loading'],
  setSubscriptionError: ['error'],
  setSubscriptionList: ['data']
});

export const SubscriptionTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: true,
  error: null,
  data: null
};

/* ------- Selectors --------- */
export const SubscriptionSelectors = {
  selectView: state => state.subscription.currentView,
  selectLoading: state => state.subscription.loading,
  selectSubscriptions: state => state.subscription.data,
  selectActiveSubscription: state => state.subscription.data,
  selectActiveSubscriptionId: state =>
    get(state, 'subscription.data.recurringBookingID'),
  selectActiveCycles: state => get(state, 'subscription.data.cycleInfo'),
  selectCycleLength: state => get(state, 'subscription.data.cycleLength'),
  selectIsPaused: state => get(state, 'subscription.data.isPaused'),
  selectIsStopped: state => !!get(state, 'subscription.data.discontinueDate'),
  selectDisabledCycleLength: state =>
    parseInt(get(state, 'subscription.data.disabledCycleLength', 0))
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setError = (state, { error }) => ({
  ...state,
  error
});

export const setSubscriptionList = (state, { data }) => ({
  ...state,
  data
});

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_SUBSCRIPTION_LOADING]: setLoading,
  [Types.SET_SUBSCRIPTION_ERROR]: setError,
  [Types.SET_SUBSCRIPTION_LIST]: setSubscriptionList
});
